<script>
import InputView from "../../../components/shared/testInput.vue";
export default {
  components: {
    InputView
  },
  props: {
    socials: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    token: {
      type: String,
      required: false
    },
    rules: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      userLocal: { ...this.user },
      socialsLocal: [...this.socials].map(social => ({ ...social, link: "" }))
    };
  },
  watch: {
    "user.socials": {
      handler: function(val) {
        if (val && val.length <= 0) {
          console.log(val, "social");
          this.socialsLocal = [...this.socials].map(social => ({
            ...social,
            link: ""
          }));
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    clearError(field) {
      this.$emit("clear-error", field);
    },
    updateSocials(id) {
      // console.log(this.socialsLocal);
      this.clearError(["socials", id]);
      this.$emit("update-socials", this.socialsLocal);
    }
  }
};
</script>
<template>
  <div class="register-subpage">
    <div class="inputs">
      <div
        class="input-wrapper"
        v-for="social in socialsLocal"
        :key="social.sct_id"
      >
        <InputView
          v-model="social.link"
          :label="social.sct_name"
          :error="errors[social.sct_id]"
          @clear-error="clearError(social.sct_id)"
          @input="updateSocials(social.sct_id)"
        />
      </div>
    </div>
    <router-link :to="{ name: 'RegisterPage1' }">
      <small v-if="!rules" class="error">{{
        $t("errors.registration.rules")
      }}</small>
    </router-link>
    <div
      class="btn dark-blue"
      :class="{ disabled: !token || !rules }"
      @click="$emit('register')"
    >
      <span v-if="token">
        {{ $t("main.registration") }}
      </span>
      <div class="spinner" v-else></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.register-subpage {
  .btn {
    width: fit-content;
    padding: 10px 30px;
    margin: 20px 0;

    text-decoration: none;

    @media screen and (max-width: 768px) {
      width: inherit;
    }
  }
  .action {
    text-align: left;
  }
  .error {
    color: $red-700;
  }
  .inputs {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 480px;
    .input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 3px;
      align-items: flex-start;
      .dropdown-wrapper {
        width: 100%;
      }
    }
    .checkbox-wrapper {
      display: flex;
      gap: 5px;
      align-items: flex-start;
      text-align: left;
      a {
        color: $light-blue-500;
      }
    }
  }
  .spinner {
    border-left-color: $white;
    border-right-color: $white;
  }
  a {
    text-decoration: none;
  }
  .error {
    display: block;
    text-align: left;
    width: fit-content;
  }
}
</style>
